import {Component, input, output} from '@angular/core';

import {SplitButtonModule} from 'primeng/splitbutton';
import {MenuItem} from 'primeng/api';

import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-split-button',
  imports: [SplitButtonModule],
  templateUrl: './split-button.component.html',
  styleUrl: './split-button.component.scss',
})
export class SplitButtonComponent {
  readonly items = input<MenuItem[] | undefined>();
  readonly label = input<string | undefined>();
  readonly icon = input<SvgSpriteIcon | undefined>();

  mainClick = output();

  handleMainClick() {
    this.mainClick.emit()
  }
}
